module.exports = __webpack_public_path__ + "static/media/dreno.29dfd876.jpg";